var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.875,
    height: 41.25,
    viewBox: "0 0 61.875 41.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M27.5-34.375a3.434,3.434,0,0,0-3.437-3.437H-8.884a3.431,3.431,0,0,0-2.428,1.01L-27.5-20.625-11.322-4.447a3.431,3.431,0,0,0,2.428,1.01H24.063A3.434,3.434,0,0,0,27.5-6.875ZM24.063-41.25a6.881,6.881,0,0,1,6.875,6.875v27.5A6.881,6.881,0,0,1,24.063,0H-8.884A6.877,6.877,0,0,1-13.75-2.009L-29.928-18.2a3.431,3.431,0,0,1-1.01-2.428,3.431,3.431,0,0,1,1.01-2.428L-13.75-39.241A6.877,6.877,0,0,1-8.884-41.25Zm-9.1,12.536a1.725,1.725,0,0,1,0,2.428L9.3-20.625l5.661,5.661a1.725,1.725,0,0,1,0,2.428,1.725,1.725,0,0,1-2.428,0L6.875-18.2,1.214-12.536a1.725,1.725,0,0,1-2.428,0,1.725,1.725,0,0,1,0-2.428l5.661-5.661-5.661-5.661a1.725,1.725,0,0,1,0-2.428,1.725,1.725,0,0,1,2.428,0l5.661,5.661,5.661-5.661A1.725,1.725,0,0,1,14.964-28.714Z",
    transform: "translate(30.938 41.25)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.015f9d46b44327e9335410b87d3560b3.svg";
export { ForwardRef as ReactComponent };